(function () {
    'use strict';
    a3_cabin_reports.directive('philoxeniaQuestions', philoxeniaQuestions);

    /**
       * @memberof CabinReports
       * @ngdoc directive
       * @name philoxeniaQuestions
       * @restrict E
       * @description
       *   Implementation of philoxenia questions 
       *
       * Display the philoxenia questions Panel
       * @attr {String} flight-id
       * @example
       *   Usage:
       *   <philoxenia-questions flight-id="123"></philoxenia-questions>
       *   
       * @ngInject
       */
    function philoxeniaQuestions(PhiloxeniaQuestionsFactory){
        /**
         * Initialize philoxeniaQuestions
         * @memberof philoxeniaQuestions
         * @param {service} scope the scope of this element
         * @param {service} element element that this direcive is assigned to
         * @param {service} attributes attributes of this element
         */
        function link(scope, element, attributes) {
            scope.togglePanel = togglePanel;
            scope.hasPhiloxeniaData = true;
            scope.philoxeniaData = null;
            scope.showPanel = showPanel();

            initializePanel();

            /**
             * Initialize Form Values
             * @memberof philoxeniaQuestions
             */
            function initializePanel(){
                var flightQuestions = PhiloxeniaQuestionsFactory.getFlightPhiloxeniaQuestionsFromStorage(+scope.flightId);
                
                if(!flightQuestions || !flightQuestions.Questions > 0 || !flightQuestions.RepliesCounter > 0){
                    scope.hasPhiloxeniaData = false;
                }
                else{
                    scope.hasPhiloxeniaData = true;
                    scope.philoxeniaData =  flightQuestions;
                }
            }
            
            function showPanel(){
                var retVal = false;
                var now = moment.utc();
                var std = moment.utc(scope.std);     
                var isAfter = now.isAfter(std);

                if(isAfter ){
                    retVal = true;
                }
    
                return retVal;
    
            }

            /**
             * Toggle Panel
             * @memberof philoxeniaQuestions
             * @param {number} panelId
             */
            function togglePanel(panelId) {
                $('#' + panelId).toggle();
            }

        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: 'views/directives/philoxeniaQuestions.tpl.html',
            scope: {
                flightId: '@',
                std:'@'
            },
            link: link
        }
    }

})();